export const EmailValidationPattern = `^[A-Za-z0-9._-]+@[A-Za-z0-9._-]+$`;

export const validateEmail = (email: string): boolean => {
  const emailRegex = new RegExp(EmailValidationPattern);
  return emailRegex.test(email);
};



// WEBPACK FOOTER //
// ./src/app/_helpers/validateEmail.ts